/* Mirrors src/hooks/use-breakpoint.ts (Breakpoints.sm=640, Breakpoints.lg=1024)
   and src/constants/theme.ts (Spacing.*) — keep in sync if those change.

   The native/shared hero-search.tsx picks these values with a JS `isSm`/
   `isLg` check that only resolves after mount, so on desktop it first
   rendered the mobile layout (stacked search fields, small title, extra
   outer padding) and snapped to the desktop one a moment later — a height
   jump on top of the earlier page-level width flash. This file lets the
   browser's media queries resolve the same breakpoints at first paint. */

.section {
  padding: 0 16px;
}

.heroImg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

@media (min-width: 1024px) {
  .section {
    padding: 0;
  }
}

.content {
  /* react-native-web's View defaults to position:relative so it paints
     above absolutely-positioned siblings (the hero image/gradient here)
     regardless of DOM order; a plain <div> doesn't get that for free. */
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

@media (min-width: 1024px) {
  .content {
    gap: 24px;
    padding: 28px;
  }
}

.title {
  margin: 0;
  font-weight: 600;
  font-size: 36px;
  line-height: 42px;
}

@media (min-width: 640px) {
  .title {
    font-size: 44px;
    line-height: 50px;
  }
}

@media (min-width: 1024px) {
  .title {
    font-size: 60px;
    line-height: 64px;
  }
}

.subtitle {
  margin: 6px 0 0;
  font-size: 16px;
  opacity: 0.9;
}

@media (min-width: 640px) {
  .subtitle {
    margin-top: 8px;
    font-size: 18px;
  }
}

.searchBar {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px;
  border-radius: 16px;
  border: 1px solid transparent;
}

@media (min-width: 640px) {
  .searchBar {
    flex-direction: row;
    align-items: center;
  }
}

.selectItem {
  min-width: 0;
}

@media (min-width: 640px) {
  .selectItem {
    flex: 1;
  }
}

.buttonWrap {
  display: flex;
  flex-direction: column;
  width: 100%;
}

@media (min-width: 640px) {
  .buttonWrap {
    width: auto;
  }
}

.statsRow {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media (min-width: 640px) {
  .statsRow {
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 24px;
    row-gap: 4px;
  }
}

.statLabel {
  font-size: 14px;
  font-weight: 500;
  opacity: 0.95;
}
